const NON_RETRYABLE_CODES = new Set(['PGRST301', '42501']);

/**
 * Auth/permission failures never succeed on retry; retrying them only
 * multiplies load on an already-rejecting backend.
 */
export function isNonRetryable(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as { status?: unknown; code?: unknown; message?: unknown };

  if (e.status === 401 || e.status === 403) return true;
  if (typeof e.code === 'string' && NON_RETRYABLE_CODES.has(e.code)) return true;

  const message = typeof e.message === 'string' ? e.message : '';
  return /invalid api key|jwt/i.test(message);
}
